import { Dispatch, SetStateAction } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, Button, MenuItem, Select } from "@mui/material";

interface ModalProps {
    open: boolean;
    onClose: () => void;
    setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function NewPolicy({
    open,
    onClose,
    setOpen,
}: ModalProps) {

    return (
        <Modal
            className="modal rejectReason_modal"
            open={open}
            onClose={onClose}
        >
            <div className="modal-dialog take_action_modal">
                <div className="modal-body">

                    {/* Header */}
                    <div className="modal_title">
                        <h2>Create New Policy</h2>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={() => setOpen(false)}
                            aria-label="Close"
                        >
                            <CloseIcon />
                        </button>
                    </div>

                    {/* Form */}
                    <form className="form">
                        <div className="gap_p">

                            {/* Policy Code */}
                            <div className="control_group w_50">
                                <label htmlFor="policy-code">Policy Code</label>
                                <TextField
                                    placeholder="POL-XXX-001"
                                    fullWidth
                                    hiddenLabel
                                    inputProps={{ id: "policy-code" }}
                                />
                            </div>
                            {/* Version */}
                           
                            {/* Title */}
                            <div className="control_group">
                                <label htmlFor="policy-title">Title</label>
                                <TextField
                                    placeholder="Policy Title"
                                    fullWidth
                                    hiddenLabel
                                    inputProps={{ id: "policy-title" }}
                                />
                            </div>
                            {/* Description */}
                            <div className="control_group ai_rec_btn">
                                <label htmlFor="policy-description">Description</label>
                                <TextField
                                    placeholder="Brief description of the policy..."
                                    fullWidth
                                    multiline
                                    rows={3}
                                    hiddenLabel
                                    inputProps={{ id: "policy-description" }}
                                />
                                <Button className="btn btn_primary sm"><img src="/static/images/ai_icon.svg" alt="" /> Enhance with AI</Button>
                            </div>

                            {/* Category */}
                            <div className="control_group w_50">
                                <label htmlFor="policy-category">Category</label>
                                <Select fullWidth size="small" defaultValue="Operational" inputProps={{ id: "policy-category" }}>
                                    <MenuItem value="Privacy">Privacy</MenuItem>
                                    <MenuItem value="Security">Security</MenuItem>
                                    <MenuItem value="Operational">Operational</MenuItem>
                                    <MenuItem value="Legal">Legal</MenuItem>
                                </Select>
                            </div>

                            {/* Status */}
                            <div className="control_group w_50">
                                <label htmlFor="policy-status">Status</label>
                                <Select fullWidth size="small" defaultValue="Draft" inputProps={{ id: "policy-status" }}>
                                    <MenuItem value="Draft">Draft</MenuItem>
                                    <MenuItem value="Active">Active</MenuItem>
                                    <MenuItem value="Under Review">Under Review</MenuItem>
                                </Select>
                            </div>

                            {/* Effective Date */}
                            <div className="control_group w_50">
                                <label htmlFor="effective-date">Effective Date</label>
                                <TextField
                                    type="date"
                                    fullWidth
                                    hiddenLabel
                                    inputProps={{ id: "effective-date" }}
                                />
                            </div>

                            {/* Review Date */}
                            <div className="control_group w_50">
                                <label htmlFor="review-date">Review Date</label>
                                <TextField
                                    type="date"
                                    fullWidth
                                    hiddenLabel
                                    inputProps={{ id: "review-date" }}
                                />
                            </div>

                            {/* Policy Content */}
                            <div className="control_group ai_rec_btn">
                                <label htmlFor="policy-content">Policy Content</label>
                                <TextField
                                    placeholder="Full policy content..."
                                    fullWidth
                                    multiline
                                    rows={6}
                                    hiddenLabel
                                    inputProps={{ id: "policy-content" }}
                                />
                                <Button className="btn btn_primary sm"><img src="/static/images/ai_icon.svg" alt="" /> Enhance with AI</Button>

                            </div>

                        </div>

                        {/* Footer */}
                        <div className="footer_btn_flex">
                            <Button
                                className="btn btn_grey"
                                variant="outlined"
                                onClick={() => setOpen(false)}
                            >
                                Cancel
                            </Button>

                            <Button
                                className="btn btn_primary"
                                onClick={() => setOpen(false)}
                            >
                                Create
                            </Button>
                        </div>
                    </form>

                </div>
            </div>
        </Modal>
    );
}
